




























import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { namespace } from 'vuex-class'

const products = namespace('products')
const stocks = namespace('stocks')
const layout = namespace('layout')

@Component({
  components: {
    OneProductOverview: () => import('./OneProductOverview.vue'),
    OneSwiperProducts: () => import('~/components/molecules/swipers/OneSwiperProduct.vue'),
  },
})
export default class OneRelatedProducts extends Vue {
  name: string = 'one-related-products'
  loading: boolean = false

  @stocks.Action fetchStocksForProductsAndWarehouses: any
  @stocks.Getter getProductOrderQuantityInWarehouse: any
  @stocks.Getter getWarehouses: any
  @stocks.Getter getDefaultWarehouseId: any
  @products.Action fetchProduct: any
  @products.Action fetchPricesForProducts: any
  @products.Getter getProduct: any
  @products.Getter getProductOrderUnit: any
  @products.Getter getProductPrice: any
  @products.Getter getProductImage: any
  @layout.Getter getCurrency: any
  @layout.Getter isGrossSelected: any

  @Prop({
    required: true,
  })
  data!: Array<any>

  @Prop({
    type: String,
    default() {
      // @ts-ignore
      return this.$t('product_page.related_products') as string
    },
  })
  title!: string

  map: any = new Map()

  get productsIds(): Array<string> {
    return this.data.filter(x => x).map(x => x.id)
  }

  async created() {
    this.loading = true
    const promises = this.data
      .map(x => x.id)
      .filter(x => x)
      .map((item: string) => this.fetchProduct(item).catch(() => null))
    if (this.$utils.isPurchaseEnabledOrAuthenticated) {
      try {
        // @ts-ignore
        const allProducts = await Promise.all(promises)
        const notNullProducts = allProducts.filter(x => x)
        await this.fetchPricesForProducts(notNullProducts.map(x => x.id))
        await this.fetchStocksForProductsAndWarehouses({
          skus: notNullProducts.map(x => x.id),
          warehouses: this.getWarehouses,
        })
      } catch (e) {
        console.warn('fetching products warn ', e)
      } finally {
        this.loading = false
      }
    }
  }
}
